// import Select from 'react-select';
// const __ = wp.i18n.__;
// const data = wp.data;
// const compose = wp.compose;
// const { withSelect, withDispatch } = data;
// if (typeof prwc_ReactSelectElementSave === 'undefined') {
// 	window.prwc_ReactSelectElementSave = {};
// }
// export default compose.compose(
// 	withDispatch(function (dispatch, props) {
// 		return {
// 			setMetaValue(metaValue) {
// 				dispatch('core/editor').editPost({
// 					meta: {
// 						[props.metaKey]: metaValue,
// 					},
// 				});
// 			},
// 			setMetaValueElement(metaValue) {
// 				prwc_ReactSelectElementSave[props.metaKey] = metaValue;
// 			},
// 		};
// 	}),
// 	withSelect(function (select, props) {
// 		let metaValue = '';
// 		metaValue = select('core/editor').getEditedPostAttribute('meta')[
// 			props.metaKey
// 		];
// 		if(Array.isArray(metaValue)){
// 			metaValue = metaValue.map(item => item.value || item.label).join(',');
// 		}

// 		let metaValueElement = prwc_ReactSelectElementSave[props.metaKey];
// 		if (!metaValueElement || !Object.keys(metaValueElement)) {
// 			metaValueElement = props.metaValueElement;
// 		}
// 		return {
// 			metaValue,
// 			metaValueElement,
// 		};
// 	})
// )(function (props) {
// 	const labels = props.options;
// 	const missingText = props.missingText;
// 	prwc_ReactSelectElementSave[props.metaKey] = props.metaValueElement;
// 	if (labels.length) {
// 		const colourStyles = {
// 			control: styles => ({ ...styles, backgroundColor: 'white' }),
// 			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
// 				let color = 'black';
// 				if(isDisabled){
// 					color = 'black';
// 				}
// 				else{
// 					if(isSelected){
// 						color = 'white';
// 					}
// 					else{
// 						if(isFocused){
// 							color = 'white';
// 						}
// 						else{
// 							color = 'black';
// 						}
// 					}
// 				}
// 				return {
// 					...styles,
// 					backgroundColor: isDisabled
// 						? null
// 						: isSelected
// 							? data.color
// 							: isFocused
// 								? '#168eff'
// 								: null,
// 					color: color,
// 					cursor: isDisabled ? 'not-allowed' : 'pointer',

// 					':active': {
// 						...styles[':active'],
// 						backgroundColor: !isDisabled && (isSelected ? data.color : '#168eff'),
// 						color: 'white',

// 					},
// 					':focus': {
// 						backgroundColor: data.color,
// 						color: 'white',
// 					},
// 					':hover': {
// 						backgroundColor: data.color,
// 						color: 'white',
// 					},
// 				};
// 			},
// 			multiValue: (styles, { data }) => {
// 				return {
// 					...styles,
// 					backgroundColor: '#168eff',
// 					color: 'white',
// 				};
// 			},
// 			multiValueLabel: (styles, { data }) => ({
// 				...styles,
// 				color: 'white',
// 			}),
// 			multiValueRemove: (styles, { data }) => ({
// 				...styles,
// 				color: 'white',
// 			}),
// 		};

// 		return (
// 			<div key={Math.random()} className={'sidebar-section'}>
// 				<label htmlFor="">{props.title}</label>
// 				<Select
// 					styles={colourStyles}
// 					value={prwc_ReactSelectElementSave[props.metaKey]}
// 					isMulti
// 					name="colors"
// 					options={labels}
// 					className="basic-multi-select"
// 					classNamePrefix="select"
// 					onChange={function (content) {
// 						props.setMetaValue(JSON.stringify(content));
// 						props.setMetaValueElement(content);
// 					}}
// 					filterOption={(candidate, input) => {
// 						if (input) {
// 							return candidate.label.includes(input);
// 						}
// 						return true;
// 					}}
// 				/>
// 			</div>
// 		);
// 	}

// 	return <label style={{color: "red"}}> {missingText} </label>;
// });





// import Select from 'react-select';
// const __ = wp.i18n.__;
// const data = wp.data;
// const compose = wp.compose;
// const { withSelect, withDispatch } = data;

// if (typeof prwc_ReactSelectElementSave === 'undefined') {
//     window.prwc_ReactSelectElementSave = {};
// }

// export default compose(
//     withDispatch(function (dispatch, props) {
//         return {
//             setMetaValue(metaValue) {
//                 dispatch('core/editor').editPost({
//                     meta: { [props.metaKey]: metaValue },
//                 });
//             },
//         };
//     }),
//     withSelect(function (select, props) {
//         // Get raw meta value directly from editor state
//         const rawMetaValue = select('core/editor').getEditedPostAttribute('meta')[props.metaKey];

//         // Parse JSON safely for React Select (expects array of {value, label} objects)
//         let selectValue = [];
//         if (rawMetaValue && typeof rawMetaValue === 'string') {
//             try {
//                 selectValue = JSON.parse(rawMetaValue) || [];
//             } catch (e) {
//                 // Invalid JSON, use empty array
//                 selectValue = [];
//             }
//         }

//         // Initialize/persist in global cache for React Select state
//         if (!prwc_ReactSelectElementSave[props.metaKey]) {
//             prwc_ReactSelectElementSave[props.metaKey] = selectValue;
//         }

//         return {
//             metaValue: rawMetaValue,      // Raw value for debugging
//             selectValue: prwc_ReactSelectElementSave[props.metaKey],  // Parsed objects for React Select
//         };
//     })
// )(function (props) {
//     const labels = props.options;
//     const missingText = props.missingText || 'No options available';

//     // Update cache whenever selectValue changes (from meta or user action)
//     prwc_ReactSelectElementSave[props.metaKey] = props.selectValue;

//     if (labels && labels.length) {
//         const colourStyles = {
//             control: styles => ({ ...styles, backgroundColor: 'white', minHeight: '36px' }),
//             option: (styles, { data, isDisabled, isFocused, isSelected }) => {
//                 const color = isDisabled ? 'black' : 
//                              isSelected ? 'white' : 
//                              isFocused ? 'white' : 'black';

//                 return {
//                     ...styles,
//                     backgroundColor: isDisabled ? null :
//                                    isSelected ? data.color || '#168eff' :
//                                    isFocused ? '#168eff' : null,
//                     color,
//                     cursor: isDisabled ? 'not-allowed' : 'pointer',
//                     ':active': {
//                         ...styles[':active'],
//                         backgroundColor: !isDisabled && (isSelected ? (data.color || '#168eff') : '#168eff'),
//                         color: 'white',
//                     },
//                     ':focus': {
//                         backgroundColor: data.color || '#168eff',
//                         color: 'white',
//                     },
//                     ':hover': {
//                         backgroundColor: data.color || '#168eff',
//                         color: 'white',
//                     },
//                 };
//             },
//             multiValue: (styles, { data }) => ({
//                 ...styles,
//                 backgroundColor: '#168eff',
//             }),
//             multiValueLabel: (styles, { data }) => ({
//                 ...styles,
//                 color: 'white',
//             }),
//             multiValueRemove: (styles, { data }) => ({
//                 ...styles,
//                 color: 'white',
//             }),
//         };

//         return (
//             <div className="sidebar-section" style={{ marginBottom: '16px' }}>
//                 <label htmlFor={props.metaKey}>{props.title}</label>
//                 <Select
//                     styles={colourStyles}
//                     value={props.selectValue}
//                     isMulti
//                     name={props.metaKey}
//                     options={labels}
//                     className="basic-multi-select"
//                     classNamePrefix="select"
//                     onChange={(selected) => {
//                         // Update both cache and WordPress meta (as JSON string)
//                         const valueToSave = selected || [];
//                         prwc_ReactSelectElementSave[props.metaKey] = valueToSave;
//                         props.setMetaValue(JSON.stringify(valueToSave));
//                     }}
//                     filterOption={(candidate, input) => {
//                         return input ? candidate.label.toLowerCase().includes(input.toLowerCase()) : true;
//                     }}
//                     placeholder="Select options..."
//                 />
//             </div>
//         );
//     }

//     return <label style={{ color: "red" }}>{missingText}</label>;
// });

// import Select from 'react-select';

// const __ = wp.i18n.__;
// const { withSelect, withDispatch } = wp.data;

// // NO compose - use direct HOC chaining
// const withMetaDispatch = withDispatch(function (dispatch, props) {
// 	console.log('🔥 withDispatch for', props.metaKey);
// 	return {
// 		setMetaValue: (metaValue) => {
// 			console.log('💾 SAVING:', metaValue);
// 			dispatch('core/editor').editPost({
// 				meta: { [props.metaKey]: JSON.parse(metaValue).map(item => item.value || item.label).join(',') }
// 			});
// 		}
// 	};
// });

// const withMetaSelect = withSelect(function (select, props) {
// 	const rawMeta = select('core/editor').getEditedPostAttribute('meta')[props.metaKey];
// 	let selectValue = [];
// 	if (rawMeta && typeof rawMeta === 'string') {
// 		try {
// 			selectValue = JSON.parse(rawMeta) || [];
// 		} catch (e) { }
// 	}
// 	return { selectValue };
// });

// // Apply HOCs directly (no compose needed)
// export default withMetaSelect(withMetaDispatch(function (props) {
// 	console.log('🎛️ Render - setMetaValue exists:', !!props.setMetaValue);

// 	if (!window.prwc_ReactSelectElementSave) {
// 		window.prwc_ReactSelectElementSave = {};
// 	}

// 	if (!props.options?.length) {
// 		return <label style={{ color: "red" }}>No options</label>;
// 	}

// 	return (
// 		<div className="sidebar-section">
// 			<label>{props.title}</label>
// 			<Select
// 				isMulti
// 				value={window.prwc_ReactSelectElementSave[props.metaKey] || props.selectValue}
// 				options={props.options}
// 				onChange={(selected) => {
// 					console.log('🎯 onChange:', selected);
// 					const jsonValue = JSON.stringify(selected || []);
// 					window.prwc_ReactSelectElementSave[props.metaKey] = selected || [];
// 					if (props.setMetaValue) {
// 						props.setMetaValue(jsonValue);
// 					} else {
// 						console.error('❌ setMetaValue missing!');
// 					}
// 				}}
// 			/>
// 		</div>
// 	);
// }));
// import Select from 'react-select';
// const { withSelect, withDispatch } = wp.data;
// const { Component } = wp.element;

// if (!window.prwc_ReactSelectElementSave) {
//     window.prwc_ReactSelectElementSave = {};
// }

// // ✅ CORRECT HOC CHAINING
// export default withSelect(function(select, props) {
//     const rawMeta = select('core/editor').getEditedPostAttribute('meta')[props.metaKey];
//     let selectValue = [];
//     if (rawMeta && typeof rawMeta === 'string') {
//         try {
//             selectValue = JSON.parse(rawMeta);
//         } catch(e) {}
//     }
//     return { selectValue };
// })(
//     withDispatch(function(dispatch, props) {
//         return {
//             setMetaValue: (metaValue) => {
//                 console.log('💾 SAVING:', metaValue);
//                 dispatch('core/editor').editPost({
//                     meta: { [props.metaKey]: 12345 }  // ← FIXED: Save JSON string directly
//                 });
//             }
//         };
//     })(
//         function(props) {
//             console.log('Render props:', props);
            
//             if (!props.options?.length) {
//                 return <label style={{color: "red"}}>No options</label>;
//             }

//             return (
//                 <div className="sidebar-section">
//                     <label>{props.title}</label>
//                     <Select
//                         isMulti
//                         value={window.prwc_ReactSelectElementSave[props.metaKey] || props.selectValue}
//                         options={props.options}
//                         onChange={(selected) => {
//                             console.log('🎯 onChange:', selected);
//                             const jsonValue = JSON.stringify(selected || []);  // JSON string
//                             window.prwc_ReactSelectElementSave[props.metaKey] = selected || [];
//                             props.setMetaValue(jsonValue);  // Save JSON to meta
//                         }}
//                     />
//                 </div>
//             );
//         }
//     )
// ); 









import Select from 'react-select';
const __ = wp.i18n.__;
const data = wp.data;
const compose = wp.compose;
const { withSelect, withDispatch } = data;
if (typeof prwc_ReactSelectElementSave === 'undefined') {
	window.prwc_ReactSelectElementSave = {};
}
export default compose.compose(
	withDispatch(function (dispatch, props) {
		return {
			setMetaValue(metaValue) {
				dispatch('core/editor').editPost({
					meta: {
						[props.metaKey]: JSON.parse(metaValue),
					},
				});
			},
			setMetaValueElement(metaValue) {
				prwc_ReactSelectElementSave[props.metaKey] = metaValue;
			},
		};
	}),
	withSelect(function (select, props) {
		let metaValue = select('core/editor').getEditedPostAttribute('meta')[
			props.metaKey
		];
		if (!metaValue) {
			metaValue = { label: '', value: '' };
		}
		let metaValueElement = prwc_ReactSelectElementSave[props.metaKey];
		if (!metaValueElement) {
			metaValueElement = props.metaValueElement;
		}
		metaValue = JSON.stringify(metaValue)
		metaValueElement = JSON.stringify(metaValueElement)
		return {
			metaValue,
			metaValueElement,
		};
	})
)(function (props) {
	const labels = props.options;
	const missingText = props.missingText;
	const metaValue = props.metaValue;
	prwc_ReactSelectElementSave[props.metaKey] = props.metaValueElement;

	if (labels) {
		return (
			<div key={Math.random()} className={'sidebar-section'}>
				<label htmlFor="">{props.title}</label>
				<Select
					value={prwc_ReactSelectElementSave[props.metaKey]}
					name="colors"
					options={labels}
					isMulti
					className="basic-multi-select"
					classNamePrefix="select"
					onChange={function (content) {
						props.setMetaValue(JSON.stringify(content));
						props.setMetaValueElement(content);
					}}
					filterOption={(candidate, input) => {
						if (input) {
							return candidate.label.includes(input);
						}
						return true;
					}}
					isClearable={true}
				/>
			</div>
		);
	}

	return <label style={{color: "red"}}> {missingText} </label>;
});
